import React, { PureComponent } from "react";

import Template from "./Alert.jsx";
import "./styles.styl";

export default class AlertController extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      active: props.active !== undefined ? props.active : true,
    };
    this.handlers = { onButtonClick: this.onButtonClick.bind(this) };
  }
  onButtonClick() {
    const { onClose } = this.props;
    this.setState({ active: false });
    onClose && onClose();
  }

  show(options) {
    const { message, colorsecondary, logosmallurl, onButtonClick } = options;
    this.setState({
      text: message,
      active: true,
      colorsecondary: colorsecondary,
      logosmallurl: logosmallurl,
      onButtonClick: onButtonClick,
    });
  }

  hide() {
    this.setState({ active: false });
  }

  render() {
    // ugly fix for getting the variables
    // because sometimes they are in props and sometimes in state
    // TODO: remove duplicate in no_access module
    const { colorSecondary, logoSmallUrl } = this.props;
    const { colorsecondary, logosmallurl } = this.state;
    const actualColorSecondary = colorSecondary || colorsecondary;
    const actualLogoSmallUrl = logoSmallUrl || logosmallurl;
    return (
      <Template
        {...this.props}
        {...this.state}
        {...this.handlers}
        colorSecondary={actualColorSecondary}
        logoSmallUrl={actualLogoSmallUrl}
      />
    );
  }
}

export function Provider(C) {
  let alert = {};
  return function Provided(props) {
    return (
      <React.Fragment>
        <C {...props} alert={alert} />
        <AlertController
          ref={(r) => {
            alert.show = (message) => r.show(message);
            alert.hide = () => r.hide();
          }}
          active={false}
        />
      </React.Fragment>
    );
  };
}
